import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { EstablishmentConfigResponseDto } from '../services/publicEstablishmentService';

interface EstablishmentStore {
  establishment: EstablishmentConfigResponseDto | null;
  currentSlug: string | null; // Armazena o slug atual para verificação
  isLoading: boolean;
  error: string | null;
  setEstablishment: (data: EstablishmentConfigResponseDto, slug: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearEstablishment: () => void;
}

export const useEstablishmentStore = create<EstablishmentStore>()(
  persist(
    (set) => ({
      establishment: null,
      currentSlug: null,
      isLoading: false,
      error: null,
      setEstablishment: (data, slug) => {
        set(() => {
          const newState = { establishment: data, currentSlug: slug, error: null };
          return newState;
        });
      },
      setLoading: (loading) => set({ isLoading: loading }),
      setError: (error) => set({ error, isLoading: false }),
      clearEstablishment: () =>
        set({ establishment: null, currentSlug: null, error: null, isLoading: false }),
    }),
    {
      name: 'establishment-storage', // Nome da chave no localStorage
      partialize: (state) => ({
        establishment: state.establishment, // Persiste os dados do estabelecimento
        currentSlug: state.currentSlug, // Persiste o slug atual
      }),
    }
  )
);
